const initialState = null;

const organizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_ORGANIZATION_SUCCESS':
      return action.payload;

    case 'UPDATE_ORGANIZATION_SUCCESS':
      return { ...state, ...action.payload };

    case 'CLEAR_ORGANIZATION':
      return null;

    case 'ADD_TO_SAVED_WIDGETS_LOCAL':
      // הוסף ווידג'ט ל-savedWidgets מקומית (לא שומר ב-Firestore)

      if (!state) {
        console.log('⚠️ organizationSetupReducer - No organization state');
        return state;
      }

      const currentSavedWidgets = state.savedWidgets || [];
      const newSavedWidgets = [...currentSavedWidgets, action.payload.widget];

      return {
        ...state,
        savedWidgets: newSavedWidgets
      };

    case 'REMOVE_FROM_SAVED_WIDGETS_LOCAL':
      // הסר ווידג'ט מ-savedWidgets מקומית (לא שומר ב-Firestore)

      if (!state || !state.savedWidgets) {
        console.log('⚠️ organizationSetupReducer - No savedWidgets to remove from');
        return state;
      }

      const updatedSavedWidgets = state.savedWidgets.filter(widget => {
        const shouldKeep = widget.widgetId !== action.payload.widgetId;
        console.log(`🔍 Checking widget ${widget.widgetId}: shouldKeep=${shouldKeep}, match=${widget.widgetId === action.payload.widgetId}`);
        return shouldKeep;
      });

      return {
        ...state,
        savedWidgets: updatedSavedWidgets
      };

    default:
      return state;
  }
};

export default organizationReducer;